import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { dOnly, useSeo } from "@/lib/fmt";
import { useStore } from "@/context/StoreContext";
import QuickShop from "@/components/store/QuickShop";

const Paras = ({ text }) => (text || "").split(/\n\n+/).map((p, i) => <p key={i} className="mt-4 leading-relaxed text-na-ink2">{p}</p>);

export function BlogList() {
  const [posts, setPosts] = useState([]);
  useSeo("Guia das plantas", "Conheça as plantas e nutrientes dos nossos produtos.");
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);
  return (
    <div className="container-na pt-10">
      <p className="eyebrow">Blog</p><h1 className="mt-2 text-4xl sm:text-5xl">Guia das plantas</h1>
      <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((b) => (
          <Link key={b.slug} to={`/blog/${b.slug}`} className="group overflow-hidden rounded-[28px] border border-na-line bg-white" data-testid={`blog-card-${b.slug}`}>
            <img src={fileUrl(b.imagem)} alt="" loading="lazy" className="h-48 w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <div className="p-6"><h2 className="font-serif text-xl">{b.titulo}</h2><p className="mt-2 text-sm text-na-ink2">{b.resumo}</p></div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const { count, setQuick } = useStore();
  const [p, setP] = useState(null);
  useSeo(p?.seo?.titulo || p?.titulo, p?.seo?.descricao);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [slug]);
  if (p === false) return <div className="container-na py-20">Post não encontrado.</div>;
  if (!p) return <div className="container-na py-20">Carregando...</div>;
  return (
    <article className="container-na max-w-3xl pt-10">
      <p className="eyebrow">Guia das plantas · {dOnly(p.publicado_em)}</p>
      <h1 className="mt-2 text-4xl sm:text-5xl" data-testid="blog-post-title">{p.titulo}</h1>
      <img src={fileUrl(p.imagem)} alt="" className="mt-8 h-72 w-full rounded-[28px] object-cover" />
      <Paras text={p.conteudo} />
      <p className="mt-8 text-xs text-na-ink2">Conteúdo informativo. Não substitui orientação médica.</p>
      <button onClick={() => setQuick("produtos")} className="fixed bottom-24 right-4 z-40 flex items-center gap-2 rounded-full bg-na-acai px-5 py-4 font-semibold text-white shadow-lg" data-testid="blog-quickshop-button">
        <ShoppingBag className="h-5 w-5" /> Loja {count > 0 && <span className="rounded-full bg-white px-2 text-xs text-na-acai">{count}</span>}
      </button>
      <QuickShop />
    </article>
  );
}

export function StaticPage() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useSeo(p?.titulo);
  useEffect(() => { api.get(`/pages/${slug}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [slug]);
  if (p === false) return <div className="container-na py-20">Página não encontrada.</div>;
  return (
    <div className="container-na max-w-3xl pt-10">
      <h1 className="text-4xl" data-testid="static-page-title">{p?.titulo}</h1>
      <Paras text={p?.conteudo} />
    </div>
  );
}
